import styled from 'styled-components/native';
import {RFValue} from 'react-native-responsive-fontsize';
import {getBottomSpace} from 'react-native-iphone-screen-helper';
import {Platform} from 'react-native';
import FontAwesome5 from 'react-native-vector-icons/FontAwesome5';

export const Container = styled.View`
padding: 0 24px;
  padding-top: ${RFValue(6)}px;
  padding-bottom: ${Platform.OS === 'ios' && getBottomSpace()
    ? 0
    : RFValue(20)}px;
`;

export const FooterPromoWrapper = styled.View`
  margin: 0 -24px ${RFValue(8)}px;
  padding: 0 24px;
`;

export const FooterPromoRow = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: ${RFValue(7)}px ${RFValue(8)}px;
  background-color: #fedcd8;
  margin: 0 -24px;
`;

export const FooterPromoTitle = styled.Text`
  flex: 1;
  color: #000;
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(10)}px;
  margin-right: ${RFValue(4)}px;
`;

export const FooterPromoTitleHighlight = styled.Text`
  color: #ea394e;
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(10)}px;
`;

export const HelpRow = styled.View`
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-bottom: ${RFValue(10)}px;
`;

export const HelpText = styled.Text`
  color: ${({theme}) => theme.colors.title};
  font-family: ${({theme}) => theme.fonts.regular};
  font-size: ${RFValue(11)}px;
`;

export const HelpLink = styled.Text`
  color: ${({theme}) => theme.colors.primary};
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(11)}px;
`;

export const TaxPromoRow = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: ${RFValue(7)}px ${RFValue(12)}px;
  background-color: #d6f0f8;
  margin: 0 -24px;
`;

export const TaxPromoText = styled.Text`
  flex: 1;
  color: #0a6a8a;
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(10)}px;
  margin-left: ${RFValue(8)}px;
`;

export const TaxPromoIcon = styled(FontAwesome5)`
  font-size: ${RFValue(12)}px;
  color: #0a6a8a;
`;

export const FooterPromoButton = styled.TouchableOpacity`
  background-color: ${({theme}) => theme.colors.shape};
  padding: ${RFValue(4)}px ${RFValue(8)}px;
  margin-left: ${RFValue(8)}px;
  border-radius: ${RFValue(8)}px;
  border: 0.2px solid #000;
  box-shadow: rgba(255, 0, 0, 0.35) 0px 5px 15px;
`;

export const FooterPromoButtonText = styled.Text`
  color: #000;
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(10)}px;
`;

export const TrustBadgesRow = styled.View`
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  margin-bottom: ${RFValue(12)}px;
`;

export const TrustBadgeItem = styled.View`
  flex: 1;
  align-items: center;
  justify-content: center;
`;

export const TrustBadgeDivider = styled.View`
  width: 1px;
  height: ${RFValue(36)}px;
  background-color: ${({theme}) => theme.colors.border};
`;

export const SenatranBadge = styled.View`
  flex-direction: row;
  align-items: center;
  gap: ${RFValue(4)}px;
`;

export const SenatranSelo = styled.Image`
  width: ${RFValue(28)}px;
  height: ${RFValue(32)}px;
`;

export const SenatranTextWrapper = styled.View``;

export const SenatranLabel = styled.Text`
  font-size: ${RFValue(6)}px;
  font-family: ${({theme}) => theme.fonts.regular};
  color: ${({theme}) => theme.colors.text};
`;

export const SenatranTitle = styled.Text`
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.bold};
  color: #5a7a2b;
`;

export const TrustBadgePercentWrapper = styled.View`
  width: ${RFValue(28)}px;
  height: ${RFValue(28)}px;
  border-radius: ${RFValue(14)}px;
  background-color: #10aeca22;
  align-items: center;
  justify-content: center;
`;

export const TrustBadgeText = styled.Text`
  font-size: ${RFValue(10)}px;
  line-height: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.title};
  text-align: left;
`;

export const TrustBadgePciImage = styled.Image`
  width: ${RFValue(58)}px;
  height: ${RFValue(29)}px;
`;
